const lower = (value) => String(value ?? '').trim().toLowerCase();
const nameOf = (first, last) => `${first ?? ''} ${last ?? ''}`.trim();

/**
 * Display name of every person a "Reports to" address can point at: the people in the file and
 * the members of the workspace, by lowercase email. The file wins when both know the address.
 *
 * @param {Array<{ person: { email: string, first_name: string, last_name: string } }>} rows
 * @param {Array<{ email: string, name: string }>} members
 * @returns {Map<string, string>}
 */
export function buildManagerNames(rows, members) {
  const names = new Map(members.map((member) => [lower(member.email), member.name]));
  rows.forEach(({ person }) => {
    const name = nameOf(person.first_name, person.last_name);
    if (name) names.set(lower(person.email), name);
  });
  return names;
}
